<template>
  <section class="button-list">
    <div v-for="(btn, index) in btnList"
         :key="index"
         class="show-button"
         @click="btnClick(btn)"
         :class="{'active': active === btn}">{{btn}}</div>
  </section>
</template>
<script>
export default {
  props: {
    btnList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    btnList: {
      handler(newVal) {
        this.active = newVal[0]
      },
      immediate: true,
    }
  },
  data() {
    return {
      active: ''
    }
  },
  methods: {
    btnClick(text) {
      this.active = text
      this.$emit('click', text)
    }
  }
}
</script>

<style scoped lang="scss">
.button-list {
  display: flex;
  gap: 12px;
  font-size: 11px;
  color: #fff;
  .show-button{
    background: rgba(102, 255, 255, 0.17);
    padding: 1px 6px;
    cursor: pointer;
    position: relative;
    &:before,&:after{
      content: '';
      position: absolute;
      display: block;
      width: 6px;
      height: 7px;
    }
    &:before{
      top: 0;
      left: 0;
      background: url("../assets/images/l.svg") no-repeat center center / 100%;
    }
    &:after{
      bottom: 0;
      right: 0;
      background: url("../assets/images/r.svg") no-repeat center center / 100%;
    }
    &.active{
      background: rgba(255, 209, 105, 0.17);
      &:before{
        background: url("../assets/images/ac-l.svg") no-repeat center center / 100%;
      }
      &:after{
        background: url("../assets/images/ac-r.svg") no-repeat center center / 100%;
      }
    }
  }
}
</style>
